import { Fragment } from 'react'
import { css } from '@emotion/react'
import { NextPage, NextPageContext } from 'next'

import { Colors } from '@/components/Landing/shared'

import { Sidebar } from '@/components/TermsAndPrivacy'
import { Header, Footer, Contact } from '@/components/Landing'

import { SIDEBAR_MENU } from '@/features/term-privacy/constants'

type Props = {}

export default function withTermsNPrivacyLayout(PageComponent: NextPage) {
  function EnhancedPageComponent(props: Props) {
    return (
      <Fragment>
        <Header isAltStyle />

        <div
          className="TermNPrivacyContainer"
          css={{
            display: 'grid',
            maxWidth: '1113px',
            margin: '0 auto',
            gridTemplateColumns: '258px 1fr',
            paddingTop: '152px',
          }}
        >
          <Sidebar menus={SIDEBAR_MENU} bottomBoundary="#endTermsContent" />
          <main css={TermNPrivacyStyles}>
            <PageComponent {...props} />
          </main>
        </div>
        <Contact />
        <Footer />
      </Fragment>
    )
  }

  EnhancedPageComponent.getInitialProps = async function (
    ctx: NextPageContext,
  ) {
    let pageProps = {}

    if (typeof PageComponent.getInitialProps === 'function') {
      pageProps = await PageComponent.getInitialProps(ctx)
    }
    return pageProps
  }

  return EnhancedPageComponent
}

const TermNPrivacyStyles = css`
  & {
    padding: 62px 0 127px 122px;
    border-left: 1px solid ${Colors.WHISPER_GREY};

    h1 {
      font-size: 48px;
      margin-bottom: 16px;
    }

    h2 {
      font-size: 32px;
      margin-bottom: 8px;
    }

    h3 {
      font-size: 24px;
      margin-bottom: 8px;
    }

    p {
      font-size: 16px;
      margin-bottom: 24px;
    }
  }
`

export const TermPrivacyLayout = ({
  children,
  menus = SIDEBAR_MENU,
}: {
  children: React.ReactNode
  menus?: TermsItem[]
}): React.ReactElement => {
  return (
    <Fragment>
      <Header isAltStyle={true} />

      <div
        className="TermNPrivacyContainer"
        css={{
          display: 'grid',
          maxWidth: '1113px',
          margin: '0 auto',
          gridTemplateColumns: '258px 1fr',
          paddingTop: '152px',
        }}
      >
        <Sidebar menus={menus} bottomBoundary="#endTermsContent" />
        <main css={TermNPrivacyStyles}>{children}</main>
      </div>

      <Footer />
    </Fragment>
  )
}
